import React from "react";
import { useTranslation } from "react-i18next";
import { ABOUT_VALUE_CARDS } from "../../constants/aboutValues";
import { SECTION_CONTAINER } from "../../utils/layout";
import ScrollReveal, { revealItemProps } from "./Reveal";

const CARD_CLASS =
  "rounded-border corner-accent-card relative flex min-h-[220px] w-full max-w-sm flex-col overflow-hidden pb-5 sm:min-h-[230px] lg:max-w-[260px]";

function AboutValueCards({ className = "" }) {
  const { t } = useTranslation();

  return (
    <ScrollReveal
      stagger
      className={`${SECTION_CONTAINER} flex flex-col items-center gap-6 pt-12 sm:flex-row sm:flex-wrap sm:justify-center sm:pt-16 lg:gap-8 ${className}`}
    >
      {ABOUT_VALUE_CARDS.map(({ id, icon, titleKey, descriptionKey }, index) => (
        <div key={id} {...revealItemProps(index, CARD_CLASS)}>
          <div className="m-auto flex w-[85%] flex-col items-center justify-center text-center">
            <img src={icon} alt="" className="w-[50px]" />
            <p className="mt-1 text-sm font-bold">{t(titleKey)}</p>
            <p className="mt-1 text-sm font-normal">{t(descriptionKey)}</p>
          </div>
        </div>
      ))}
    </ScrollReveal>
  );
}

AboutValueCards.revealManaged = true;

export default AboutValueCards;
